import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ChartPieIcon, MapIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { NavLink, Outlet } from "react-router-dom";
import { HiOutlineChartBar } from "react-icons/hi";
import { LuGlobe } from "react-icons/lu";
import Logo from "./Logo";
const navigation = [
  { name: "Dashboard", href: "/", icon: ChartPieIcon, current: false },
  { name: "Live View", href: "map", icon: MapIcon, current: false },
  // {
  //   name: "Recent Flights",
  //   href: "historic-map",
  //   icon: TbMapSearch,
  //   current: false,
  // },
  { name: "Heatmap", href: "heatmap", icon: LuGlobe, current: false },
  {
    name: "Analytics",
    href: "analytics",
    icon: HiOutlineChartBar,
    current: false,
    children: [
      { name: "Users", href: "users", current: false },
      { name: "Aircrafts", href: "aircrafts", current: false },
    ],
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Layout = ({ children, onLinkClick }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <div className="h-full">
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50 lg:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </Transition.Child>

            <div className="fixed inset-0 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button
                        type="button"
                        className="-m-2.5 p-2.5"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  {/* Sidebar component, swap this element with another sidebar if you like */}
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                    <div className="flex h-16 shrink-0 items-center">
                      <img
                        className="h-8 w-auto"
                        src="/Images/aerowatch_logo.svg"
                        alt="Your Company"
                      />
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul className="-mx-2 space-y-1">
                            {navigation.map((item) => (
                              <li key={item.name}>
                                <NavLink
                                  to={item.href}
                                  className={({ isActive, isPending }) =>
                                    classNames(
                                      isActive
                                        ? "bg-gray-50 text-purple-600"
                                        : "text-gray-700 hover:text-purple-600 hover:bg-gray-50",
                                      "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                                    )
                                  }
                                >
                                  <item.icon
                                    className={classNames(
                                      item.current
                                        ? "text-purple-600"
                                        : "text-gray-400 group-hover:text-purple-600",
                                      "h-6 w-6 shrink-0"
                                    )}
                                    aria-hidden="true"
                                  />
                                  {item.name}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
            <div className="flex shrink-0 items-end  mt-4">
              <Logo size="small" />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <>
                        <li key={item.name}>
                          <NavLink
                            onClick={onLinkClick}
                            to={
                              item.children
                                ? item.href + "/" + item.children[0].href
                                : item.href
                            }
                            className={({ isActive, isPending }) =>
                              classNames(
                                isActive
                                  ? "bg-gray-50 text-purple-600"
                                  : "text-gray-700 hover:text-purple-600 hover:bg-gray-50",
                                "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                              )
                            }
                          >
                            {({ isActive, isPending }) => (
                              <>
                                <item.icon
                                  className={classNames(
                                    isActive
                                      ? "text-purple-600"
                                      : "text-gray-400 group-hover:text-purple-600",
                                    "h-6 w-6 shrink-0"
                                  )}
                                  aria-hidden="true"
                                />
                                {item.name}
                              </>
                            )}
                          </NavLink>
                        </li>

                        {item.children &&
                          item.children.map((child) => (
                            <NavLink
                              to={item.href + "/" + child.href}
                              className={({ isActive, isPending }) =>
                                classNames(
                                  isActive
                                    ? "bg-gray-50 text-purple-600"
                                    : "text-gray-700 hover:text-purple-600 hover:bg-gray-50",
                                  "group flex gap-x-3 rounded-md p-2 text-sm leading-6 "
                                )
                              }
                            >
                              <div className="h-6 w-6"></div>
                              {child.name}
                            </NavLink>
                          ))}
                      </>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="lg:pl-72 h-full">
          <main className="py-10 h-full ">
            <div className="mx-auto px-4 sm:px-6 lg:px-8 h-full pb-12 ">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Layout;
